import React from 'react';
import { Link } from 'react-router-dom';
import '../../../assets/styles/LandingPage/BannerCampana.css';

const BannerCampana = () => {
  return (
    <section className="banner-campana">
      <div className="banner-campana__container">
        <div className="banner-campana__content">
          <div className="banner-campana__badge">
            🎯 Campaña Temporada Alta
          </div>
          <h2 className="banner-campana__title">
            ¿Querés que tu alojamiento sea la primera opción?
          </h2>
          <p className="banner-campana__subtitle">
            En Carnaval y Semana Santa todos buscan. Asegurate de que te encuentren primero.
          </p>
          <div className="banner-campana__features">
            <div className="banner-campana__feature">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <polyline points="20 6 9 17 4 12" />
              </svg>
              <span>Mejor posición en búsquedas</span>
            </div>
            <div className="banner-campana__feature">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <polyline points="20 6 9 17 4 12" />
              </svg>
              <span>Etiqueta "Destacado"</span>
            </div>
            <div className="banner-campana__feature">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <polyline points="20 6 9 17 4 12" />
              </svg>
              <span>Menor comisión</span>
            </div>
          </div>
          <Link to="/campana-visibilidad" className="banner-campana__cta">
            Ver planes disponibles
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <line x1="5" y1="12" x2="19" y2="12" />
              <polyline points="12 5 19 12 12 19" />
            </svg>
          </Link>
        </div>
        <div className="banner-campana__visual">
          <div className="banner-campana__icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="80" height="80" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
              <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
            </svg>
          </div>
          <div className="banner-campana__stats">
            <div className="banner-campana__stat">
              <div className="banner-campana__stat-number">3x</div>
              <div className="banner-campana__stat-label">Más vistas</div>
            </div>
            <div className="banner-campana__stat">
              <div className="banner-campana__stat-number">2 meses</div>
              <div className="banner-campana__stat-label">Duración</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BannerCampana;
